/**
 * CSS injected by react-to-print (`pageStyle` prop) for @page and print media.
 */
export const PRESCRIPTION_PRINT_PAGE_STYLE = `
  @page {
    size: auto;
    margin: 12mm;
  }
  @media print {
    html, body {
      height: auto !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`
